import { SponsorRequestStatus } from 'EstraSponsor'
import { Theme } from 'styled-components'

export const sponsorRequestStatusColor: {
  [key in SponsorRequestStatus]: keyof Theme['color']['primari']
} = {
  draft: 'grigioEstra',
  new: 'ciano',
  rejected: 'fucsia',
  in_progress: 'arancione',
  approved_with_changes: 'arancione',
  approved: 'verde',
  finalized_to_sign: 'arancione',
  finalized_signed: 'arancione',
  finalized_canceled: 'fucsia',
  finalized: 'verde',
  canceled: 'fucsia',
  expired: 'neroEstra',
}

export const sponsorRequestStatusDictionary: {
  [key in SponsorRequestStatus]: string
} = {
  draft: 'Bozza',
  new: 'Nuova',
  rejected: 'Rifiutata',
  in_progress: 'In elaborazione',
  approved_with_changes: 'Approvata con modifiche',
  approved: 'Approvata',
  finalized_to_sign: 'Da firmare',
  finalized_signed: 'In elaborazione',
  finalized_canceled: 'Cancellata',
  finalized: 'Completata',
  canceled: 'Rifiutata',
  expired: 'Scaduta',
}
